import AgentHome from "./home";

export default AgentHome;
